import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/types';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.setup || initialState;

export const selectSetup = createSelector(
  [selectDomain],
  setupState => setupState,
);
